export const isNotNull = <T>(value: T) => value !== null && value !== undefined;

export const isObject = (value?: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);
